import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  Optional,
  Self,
} from "@angular/core";
import {
  ControlValueAccessor,
  NgControl,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { NgIf } from "@angular/common";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { passwordStrengthValidator } from "../../validators/password-strength.validator";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
  standalone: true,
  imports: [NgIf, TooltipModule, ReactiveFormsModule, TranslocoPipe],
  selector: "er-smart-password-field",
  templateUrl: "./smart-password-field.component.html",
  styleUrls: ["./smart-password-field.component.scss"],
})
export class SmartPasswordFieldComponent
  implements ControlValueAccessor, AfterViewInit
{
  @Input() minlength: number = 8;
  @Input() disabled: boolean = false;

  value = "";
  touched = false;
  showTooltip = false;
  isPasswordVisible = false;

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    private cdr: ChangeDetectorRef
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngAfterViewInit() {
    if (this.ngControl) {
      this.ngControl.control?.valueChanges.subscribe((val) => {
        this.writeValue(val);
        this.showTooltip = this.shouldShowTooltip();
      });
      this.ngControl?.control &&
        this.ngControl.control.setValidators([
          Validators.minLength(this.minlength),
          passwordStrengthValidator(),
        ]);
      this.ngControl.control?.updateValueAndValidity();
    }
  }

  writeValue(value: any): void {
    this.value = value;
    this.showTooltip = this.shouldShowTooltip();
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value);
    this.onTouched();
    this.ngControl.control?.setValue(this.value);
    this.ngControl.control?.updateValueAndValidity();

    this.showTooltip = this.shouldShowTooltip();
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  markAsTouched() {
    this.touched = true;
    this.onTouched();
  }

  shouldShowTooltip(): boolean {
    return this.value.length > 0;
  }

  showPassword(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
}
